import * as React from 'react';

/**
 * Props type for JRCColumnCenter
 * @member children enclosed React component
 */
export interface JRCColumnCenterProps {
    children: React.ReactNode;
}

export const JRCColumnCenter = (props: JRCColumnCenterProps) => <div id="r-main">{props.children}</div>;
